/**
 * Make and model are not independent filters, and the URL has to know it.
 *
 * `?make=Porsche&model=911` is one thought. Change the make to Ferrari and the model half
 * stops meaning anything: the two are ANDed, no car is both, and the catalogue goes empty
 * with nothing on screen to say why — the model chip is still sitting there looking valid.
 *
 * So whenever the make selection changes, the models come with it, and any model the new
 * selection does not cover is dropped. Clearing the makes entirely drops nothing: a model
 * chosen with no marque beside it is a perfectly good filter on its own.
 */
export function narrowModels(models, makes, catalogue) {
  if (!makes.length || !catalogue?.models) return models;
  const covered = new Set(makes.flatMap((m) => (catalogue.models[m] ?? []).map((x) => x.name)));
  return models.filter((m) => covered.has(m));
}
